<template>
  <div>
    <v-layout wrap v-if="storage">
      <v-flex xs6 sm2 md3>
        <v-layout wrap justify-center v-if="storage.productId">
          <!-- <template v-for="(photos, j) in storage.productId"> -->
          <v-flex
            v-if="storage.productId.photos"
            pa-1
            text-text-left
            align-self-center
          >
          <router-link
                  :to="
                    '/Seller/Orders/' +
                      storage.order_id +
                      '?prod=' +
                      storage._id
                  "
                >
            <v-img
              :src="mediaURL + storage.productId.photos[0]"
              height="100px"
              contain
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="#FF2323"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </router-link>
          </v-flex>
          <!-- </template> -->
        </v-layout>
      </v-flex>
      <v-flex xs12 sm10 md9>
        <v-layout wrap justify-center fill-height>
          <v-flex xs12 sm9 md9 lg9 xl10 text-left>
            <v-layout wrap justify-start style="line-height: 16px" fill-height>
              <v-flex xs12 align-self-start>
                <span
                  style="
                    font-family: poppinsregular;
                    font-size: 12px;
                    color: #42af54;
                  "
                >
                  Order No : {{ storage.orderID }}
                </span>
              </v-flex>
              <v-flex xs12 align-self-start>
                <router-link
                  :to="
                    '/Seller/Orders/' +
                      storage.order_id +
                      '?prod=' +
                      storage._id
                  "
                >
                  <span
                    style="
                      font-family: poppinsmedium;
                      font-size: 16px;
                      color: #000000;
                    "
                  >
                    {{ storage.name.slice(0, 25) }}
                    <span v-if="storage.name.length > 25">...</span>
                  </span>
                </router-link>
              </v-flex>
              <!-- <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 12px;
                    color: #000000;
                  "
                >
                  {{ storage.product.length }} Item<span
                    v-if="storage.product.length > 1"
                    >'s</span
                  >
                </span>
              </v-flex> -->
              <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 13px;
                    color: #000000;
                  "
                >
                  Rs. {{ storage.offerPrice }}
                </span>
                <br />
                <del>
                  <span
                    style="
                    font-family: poppinssemibold;
                    font-size: 13px;
                    color: #000000;
                  "
                  >
                    Rs. {{ storage.price }}
                  </span>
                </del>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 13px;
                    color: #000000;
                  "
                >
                  , {{ storage.discount }} % Off
                </span>
              </v-flex>
              <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 12px;
                    color: #6c6c6c;
                  "
                >
                  Quantity Purchased : &nbsp;<v-btn small outlined>{{
                    storage.quantity
                  }}</v-btn>
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["storage"],
  data() {
    return {};
  },
};
</script>
